import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMConst from 'lib/SMConst';

class SMUnapprovedBillingList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  renderPlan(reservation, unapprovedReservation) {
    const planName = SMFormatHelper.planName(reservation.plan || reservation.room);
    const unapprovedPlanName = SMFormatHelper.planName(unapprovedReservation.plan || unapprovedReservation.room);

    const planId = reservation.plan_id;
    const unapprovedPlanId = unapprovedReservation.plan_id;

    const roomAmount = reservation.billing.room_amount;
    const unapprovedRoomAmount = unapprovedReservation.billing.room_amount;


    const rows = [];

    if (planId == unapprovedPlanId && roomAmount == unapprovedRoomAmount) {
      return (
        <div className="reserve-detail-box">
          <h3 className="reserve-detail-box__title">スペース利用料</h3>
          <p className="fl w450">{planName}</p>
          {rows}
          <p className="fr">{reservation.billing.room_amount_text}</p>
        </div>
      );
    } else
      return (
        <div className="reserve-detail-box">
          <h3 className="reserve-detail-box__title">スペース利用料</h3>
          <div className="clearfix mt5">
            <p className="fl w450">
              <del>{planName}</del>
            </p>
            {rows}
            <p className="fr">
              <del>{reservation.billing.room_amount_text}</del>
            </p>
          </div>
          <div className="clearfix mt5">
            <p className="fl w450">
              <ins>{unapprovedPlanName}</ins>
            </p>
            {rows}
            <p className="fr">
              <ins>{unapprovedReservation.billing.room_amount_text}</ins>
            </p>
          </div>
        </div>
      );
  }

  renderOptionItems(items, unapprovedItems) {
    const rows = [];
    if (items == null) items = [];
    if (unapprovedItems == null) unapprovedItems = [];

    const itemHash = {};
    const unapprovedItemHash = {};

    let allIds = [];
    for (let i = 0; i < items.length; i++) {
      allIds.push(items[i].option_item_id);
      itemHash[items[i].option_item_id] = items[i];
    }

    for (let i = 0; i < unapprovedItems.length; i++) {
      if (allIds.indexOf(unapprovedItems[i].option_item_id) < 0) {
        allIds.push(unapprovedItems[i].option_item_id);
      }
      unapprovedItemHash[unapprovedItems[i].option_item_id] = unapprovedItems[i];
    }

    allIds = allIds.sort((a, b) => {
      return (parseInt(a) > parseInt(b)) ? 1 : -1;
    });

    for (let id in allIds) {
      let optionId = allIds[id];
      let item = itemHash[optionId];
      let unapprovedItem = unapprovedItemHash[optionId];

      if (item && unapprovedItem) {
        if (item.total_amount == unapprovedItem.total_amount) {
          // itemのみの表示
          rows.push(
            <div key={optionId} className="reserve-detail-box">
              <h3 className="reserve-detail-box__title">オプション</h3>
              <p className="fl w450">{item.name}</p>
              <p className="fl">{SMFormatHelper.reservationOptionQuantity(item)}</p>
              <p className="fr">{item.total_amount_text}</p>
            </div>
          );
        } else {
          // 差分表示
          rows.push(
            <div key={optionId} className="reserve-detail-box">
              <h3 className="reserve-detail-box__title">オプション</h3>
              <div className="clearfix mt5">
                <p className="fl w450">
                  <del>{item.name}</del>
                </p>
                <p className="fl">
                  <del>{SMFormatHelper.reservationOptionQuantity(item)}</del>
                </p>
                <p className="fr">
                  <del>{item.total_amount_text}</del>
                </p>
              </div>
              <div className="clearfix mt5">
                <p className="fl w450">
                  <ins>{unapprovedItem.name}</ins>
                </p>
                <p className="fl">
                  <ins>{SMFormatHelper.reservationOptionQuantity(unapprovedItem)}</ins>
                </p>
                <p className="fr">
                  <ins>{unapprovedItem.total_amount_text}</ins>
                </p>
              </div>
            </div>
          );
        }
      } else if (item) {
        // item差分表示
        rows.push(
          <div key={optionId} className="reserve-detail-box">
            <h3 className="reserve-detail-box__title">オプション</h3>
            <div className="clearfix mt5">
              <p className="fl w450">
                <del>{item.name}</del>
              </p>
              <p className="fl">
                <del>{SMFormatHelper.reservationOptionQuantity(item)}</del>
              </p>
              <p className="fr">
                <del>{item.total_amount_text}</del>
              </p>
            </div>
          </div>
        );
      } else {
        // unapprovedItem表示
        rows.push(
          <div key={optionId} className="reserve-detail-box">
            <h3 className="reserve-detail-box__title">オプション</h3>
            <p className="fl w450">{unapprovedItem.name}</p>
            <p className="fl">{SMFormatHelper.reservationOptionQuantity(unapprovedItem)}</p>
            <p className="fr">{unapprovedItem.total_amount_text}</p>
          </div>
        );
      }
    }
    return rows;
  }

  renderOptionFoods(foods, unapprovedFoods) {
    const rows = [];
    if (foods == null) foods = [];
    if (unapprovedFoods == null) unapprovedFoods = [];

    const foodHash = {};
    const unapprovedFoodHash = {};

    let allIds = [];
    for (let i = 0; i < foods.length; i++) {
      allIds.push(foods[i].option_food_id);
      foodHash[foods[i].option_food_id] = foods[i];
    }

    for (let i = 0; i < unapprovedFoods.length; i++) {
      if (allIds.indexOf(unapprovedFoods[i].option_food_id) < 0) {
        allIds.push(unapprovedFoods[i].option_food_id);
      }
      unapprovedFoodHash[unapprovedFoods[i].option_food_id] = unapprovedFoods[i];
    }

    allIds = allIds.sort((a, b) => {
      return (parseInt(a) > parseInt(b)) ? 1 : -1;
    });

    for (let id in allIds) {
      let optionId = allIds[id];
      let food = foodHash[optionId];
      let unapprovedFood = unapprovedFoodHash[optionId];

      if (food && unapprovedFood) {
        if (food.total_amount == unapprovedFood.total_amount) {
          // foodのみの表示
          rows.push(
            <div key={optionId} className="reserve-detail-box">
              <h3 className="reserve-detail-box__title">飲食</h3>
              <p className="fl w450">{food.name}</p>
              <p className="fl">{SMFormatHelper.reservationOptionQuantity(food)}</p>
              <p className="fr">{food.total_amount_text}</p>
            </div>
          );
        } else {
          // 差分表示
          rows.push(
            <div key={optionId} className="reserve-detail-box">
              <h3 className="reserve-detail-box__title">飲食</h3>
              <div className="clearfix mt5">
                <p className="fl w450">
                  <del>{food.name}</del>
                </p>
                <p className="fl">
                  <del>{SMFormatHelper.reservationOptionQuantity(food)}</del>
                </p>
                <p className="fr">
                  <del>{food.total_amount_text}</del>
                </p>
              </div>
              <div className="clearfix mt5">
                <p className="fl w450">
                  <ins>{unapprovedFood.name}</ins>
                </p>
                <p className="fl">
                  <ins>{SMFormatHelper.reservationOptionQuantity(unapprovedFood)}</ins>
                </p>
                <p className="fr">
                  <ins>{unapprovedFood.total_amount_text}</ins>
                </p>
              </div>
            </div>
          );
        }
      } else if (food) {
        // food差分表示
        rows.push(
          <div key={optionId} className="reserve-detail-box">
            <h3 className="reserve-detail-box__title">飲食</h3>
            <div className="clearfix mt5">
              <p className="fl w450">
                <del>{food.name}</del>
              </p>
              <p className="fl">
                <del>{SMFormatHelper.reservationOptionQuantity(food)}</del>
              </p>
              <p className="fr">
                <del>{food.total_amount_text}</del>
              </p>
            </div>
          </div>
        );
      } else {
        // unapprovedFood表示
        rows.push(
          <div key={optionId} className="reserve-detail-box">
            <h3 className="reserve-detail-box__title">飲食</h3>
            <p className="fl w450">{unapprovedFood.name}</p>
            <p className="fl">{SMFormatHelper.reservationOptionQuantity(unapprovedFood)}</p>
            <p className="fr">{unapprovedFood.total_amount_text}</p>
          </div>
        );
      }
    }
    return rows;
  }

  renderChangedPrice(reservation, unapprovedReservation) {
    if (reservation.billing.change_amount == 0.0 && unapprovedReservation.billing.change_amount == 0.0) {
      return null;
    } else if (reservation.billing.change_amount == 0.0) {
      // unapprovedのみ表示
      return (
        <div className="reserve-detail-box">
          <p className="fl">価格変更({unapprovedReservation.billing.change_description})</p>
          <p className="fr">{unapprovedReservation.billing.change_amount_text}</p>
        </div>
      );
    } else if (unapprovedReservation.billing.change_amount == 0.0) {
      // reservationのみ表示
      return (
        <div className="reserve-detail-box">
          <div className="clearfix mt5">
            <p className="fl">
              <del>価格変更({reservation.billing.change_description})</del></p>
            <p className="fr">
              <del>{reservation.billing.change_amount_text}</del>
            </p>
          </div>
        </div>
      );
    } else {
      // 両方表示
      return (
        <div className="reserve-detail-box">
          <div className="clearfix mt5">
            <p className="fl">
              <del>価格変更({reservation.billing.change_description})</del>
            </p>
            <p className="fr">
              <del>{reservation.billing.change_amount_text}</del>
            </p>
          </div>
          <div className="clearfix mt5">
            <p className="fl">
              <ins>価格変更({unapprovedReservation.billing.change_description})</ins></p>
              <p className="fr">
                <ins>{unapprovedReservation.billing.change_amount_text}</ins>
              </p>
          </div>
        </div>
      );
    }
  }

  renderLastMinuteDiscount(reservation, unapprovedReservation) {
    if (
      reservation.billing.last_minute_discount_amount_except_tax == 0.0 &&
      unapprovedReservation.billing.last_minute_discount_amount_except_tax == 0.0
    ) {
      return null;
    } else if (
      reservation.billing.last_minute_discount_amount_except_tax == 0.0 ||
      (reservation.billing.last_minute_discount_amount_except_tax === unapprovedReservation.billing.last_minute_discount_amount_except_tax)
    ) {
      return (
        <div className="reserve-detail-box">
          <p className="fl">直前割</p>
          <p className="fr"><span className="is-minus">- {reservation.billing.last_minute_discount_amount_except_tax_text}</span></p>
        </div>
      );
    } else if (unapprovedReservation.billing.last_minute_discount_amount_except_tax == 0.0) {
      // 直前割が外れるパターン
      return (
        <div className="reserve-detail-box">
          <div className="clearfix mt5">
            <p className="fl">
              <del>直前割</del>
            </p>
            <p className="fr">
              <del><span className="is-minus">- {reservation.billing.last_minute_discount_amount_except_tax_text}</span></del>
            </p>
          </div>
        </div>
      );
    } else {
      // 両方表示
      return (
        <div className="reserve-detail-box">
          <div className="clearfix mt5">
            <p className="fl">
              <del>直前割</del>
            </p>
            <p className="fr">
              <del><span className="is-minus">- {reservation.billing.last_minute_discount_amount_except_tax_text}</span></del>
            </p>
          </div>
          <div className="clearfix mt5">
            <p className="fl">
              <ins>直前割</ins></p>
              <p className="fr">
                <ins><span className="is-minus">- {unapprovedReservation.billing.last_minute_discount_amount_except_tax_text}</span></ins>
              </p>
          </div>
        </div>
      );
    }
  }

  renderGuestFee(reservation, unapprovedReservation) {
    const guestFeeAmount = reservation.billing.guest_fee_amount;
    const unapprovedGuestFeeAmount = unapprovedReservation.billing.guest_fee_amount;

    if (reservation.billing.guest_fee_amount == 0.0) {
      return null;
    }

    if (!this.props.isOwner && reservation.billing.guest_fee_amount_text && unapprovedReservation.billing.guest_fee_amount_text) {
      if (reservation.billing.guest_fee_amount == unapprovedReservation.billing.guest_fee_amount) {
        return (
          <div className="reserve-detail-box">
            <p className="fl">サービス料</p>
            <p className="fr">{reservation.billing.guest_fee_amount_text}</p>
          </div>
        );
      } else {
        return (
          <div className="reserve-detail-box">
            <div className="clearfix mt5">
              <p className="fl">サービス料</p>
              <p className="fr">
                <del>{reservation.billing.guest_fee_amount_text}</del>
              </p>
            </div>
            <div className="clearfix mt5">
            <p className="fr">
              <ins>{unapprovedReservation.billing.guest_fee_amount_text}</ins>
            </p>
            </div>
          </div>
        );
      }
    }
    return null;
  }

  renderGuestPostpayFee(reservation, unapprovedReservation) {
    if (this.props.isOwner || reservation.billing.payment_method !== SMConst.PaymentMethod.Postpay) return null;

    if (reservation.billing.guest_postpay_fee_amount_text && unapprovedReservation.billing.guest_postpay_fee_amount_text) {
      if (reservation.billing.guest_postpay_fee_amount === unapprovedReservation.billing.guest_postpay_fee_amount) {
        return (
          <div className="reserve-detail-box">
            <p className="fl">後払い手数料</p>
            <p className="fr">{reservation.billing.guest_postpay_fee_amount_text}</p>
          </div>
        );
      } else {
        return (
          <div className="reserve-detail-box">
            <div className="clearfix mt5">
              <p className="fl">後払い手数料</p>
              <p className="fr">
                <del>{reservation.billing.guest_postpay_fee_amount_text}</del>
              </p>
            </div>
            <div className="clearfix mt5">
              <p className="fr">
                <ins>{unapprovedReservation.billing.guest_postpay_fee_amount_text}</ins>
              </p>
            </div>
          </div>
        );
      }
    }
  }

  renderPointDiscount(reservation, unapproved_reservation) {
    if (this.props.isOwner || !unapproved_reservation.billing.is_applied_point) {
      return null;
    }

    return (
      <div className="reserve-detail-box">
        <p className="fl">ポイント割引</p>
        <p className="fr">
          <span className="db"><del>- {reservation.billing.point_discount_amount_text}</del></span>
          <span className="db mt5 is-minus"><ins>- {unapproved_reservation.billing.point_discount_amount_text}</ins></span>
        </p>
      </div>
    );
  }

  renderSalesTax(reservation, unapprovedReservation) {
    if (reservation.billing.sales_tax_text == unapprovedReservation.billing.sales_tax_text) {
      return (
        <div className="reserve-detail-box">
          <p className="fl w450">消費税</p>
          <p className="fr">{this.props.isOwner ? reservation.billing.sales_tax_text
            : reservation.billing.guest_sales_tax_text}</p>
        </div>
      );
    } else {
      return (
        <div className="reserve-detail-box">
          <p className="fl w450">消費税</p>
          <div className="clearfix mt5">
            <p className="fr">
              <del>{this.props.isOwner ? reservation.billing.sales_tax_text
                : reservation.billing.guest_sales_tax_text}</del>
            </p>
          </div>
          <div className="clearfix mt5">
            <p className="fr">
              <ins>{this.props.isOwner ? unapprovedReservation.billing.sales_tax_text
                : unapprovedReservation.billing.guest_sales_tax_text}</ins>
            </p>
          </div>
        </div>
      );
    }
  }

  renderSubTotal(reservation, unapprovedReservation) {
    if (this.props.isOwner || !reservation.billing.is_applied_coupon) {
      return null;
    }

    if (reservation.billing.guest_total_amount_with_tax_text == unapprovedReservation.billing.guest_total_amount_with_tax_text) {
      return (
        <div className="reserve-detail-box">
          <p className="fl">小計</p>
          <p className="fr">
            {reservation.billing.guest_total_amount_with_tax_text}
          </p>
        </div>
      );
    } else {
      return (
        <div className="reserve-detail-box">
          <p className="fl">小計</p>
          <p className="fr">
            <span className="db"><del>{reservation.billing.guest_total_amount_with_tax_text}</del></span>
            <span className="db mt5"><ins>{unapprovedReservation.billing.guest_total_amount_with_tax_text}</ins></span>
          </p>
        </div>
      );
    }
  }

  renderDiscount(reservation, unapprovedReservation) {
    if (!this.props.isOwner && reservation.billing.is_applied_coupon) {
      if (reservation.billing.discount_amount_text == unapprovedReservation.billing.discount_amount_text) {
        return (
          <div className="reserve-detail-box">
            <p className="fl">クーポン割引</p>
            <p className="fr"><span className="is-minus">- {reservation.billing.discount_amount_text}</span></p>
          </div>
        );
      } else {
        return (
          <div className="reserve-detail-box">
            <p className="fl">クーポン割引</p>
            <p className="fr">
              <span className="db is-minus"><del>- {reservation.billing.discount_amount_text}</del></span>
              <span className="db mt5 is-minus"><ins>- {unapprovedReservation.billing.discount_amount_text}</ins></span>
            </p>
          </div>
        );

      }
    }
    return null;
  }

  renderTotal(reservation, unapprovedReservation) {

    if (reservation.billing.total_amount_with_tax_text == unapprovedReservation.billing.total_amount_with_tax_text) {
      return (
        <div className="reserve-detail-box">
          <p className="fl">合計</p>
          <p className="fr">
            {this.props.isOwner ? reservation.billing.total_amount_with_tax_text
              : reservation.billing.total_pay_amount_for_user_with_tax_text}
          </p>
        </div>
      );
    } else {
      return (
        <div className="reserve-detail-box">
          <p className="fl">合計</p>
          <p className="fr">
            <span className="db"><del>{this.props.isOwner ? reservation.billing.total_amount_with_tax_text
              : reservation.billing.total_pay_amount_for_user_with_tax_text}</del></span>
            <span className="db mt5"><ins>{this.props.isOwner ? unapprovedReservation.billing.total_amount_with_tax_text
              : unapprovedReservation.billing.total_pay_amount_for_user_with_tax_text}</ins></span>
          </p>
        </div>
      );
    }

  }

  renderPoint(reservation, unapproved_reservation) {
    if(this.props.isOwner || !reservation.point_amount_text) { return null; }

    return (
      <p className="reserve-detail__point">このスペース利用で<span className="reserve-detail__point-have"><del>{reservation.point_amount_text}</del></span><del>ポイント</del><span className="reserve-detail__point-have"><ins>{unapproved_reservation.point_amount_text}</ins></span><ins>ポイント</ins>獲得予定です。</p>
    );
  }

  render() {
    const reservation = this.props.reservation;
    const unapproved_reservation = this.props.unapproved_reservation;

    return (
      <div>
        {this.renderPlan(reservation, unapproved_reservation)}
        {this.renderOptionItems(reservation.reserved_option_items, unapproved_reservation.reserved_option_items)}
        {this.renderOptionFoods(reservation.reserved_option_foods, unapproved_reservation.reserved_option_foods)}
        {this.renderChangedPrice(reservation, unapproved_reservation)}
        {this.renderLastMinuteDiscount(reservation, unapproved_reservation)}
        {this.renderGuestFee(reservation, unapproved_reservation)}
        {this.renderGuestPostpayFee(reservation, unapproved_reservation)}
        {this.renderPointDiscount(reservation, unapproved_reservation)}
        {this.renderSalesTax(reservation, unapproved_reservation)}
        {this.renderSubTotal(reservation, unapproved_reservation)}
        {this.renderDiscount(reservation, unapproved_reservation)}
        {this.renderTotal(reservation, unapproved_reservation)}
        {this.renderPoint(reservation, unapproved_reservation)}
      </div>
    );
  }
}
export default SMUnapprovedBillingList;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/reservations/SMUnapprovedBillingList.jsx